(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Prefecture', Prefecture);

    Prefecture.$inject = ['$resource'];

    function Prefecture ($resource) {
        var resourceUrl =  'api/prefectures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
